import { formatAsLongMonthAndYear } from "../../../core/helpers/date-formatting-util.js";
import AccountingDocumentWidget from "../../shared/documentInfrastructure/AccountingDocumentWidget.js";
import ForecastArchiveCardWidget from "../widgets/ForecastArchiveCardWidget/ForecastArchiveCardWidget.js";
import makeCardGroupListWidget from "../../../core/widgets/list/CardGroupListWidget/makeCardGroupListWidget.js";
import regionWidget from "../../../core/widgets/regionWidget.js";

/**
 * Widget rendering published forecasts.
 *
 * @param {function(): string} getForecastUrl - Return the URL where
 *   the user is expected to go when clicking a forecast
 */
export default class ForecastArchiveDocumentContent extends AccountingDocumentWidget {
	setup({ getForecastUrl = () => {} }) {
		super.setup(...arguments);

		this._getForecastUrl = getForecastUrl;

		this._listSource = this._getPublishedForecastSource();

		this._publishedForecastList = makeCardGroupListWidget({
			source: this._listSource,
			itemRenderer: this._forecastCardRenderer.bind(this),
			groupLabelRenderer: this._forecastCardGroupRenderer.bind(this),
			cssClass: "forecast-card-list",
			compareFunction: this._sortGroupPeriods.bind(this),
		});
	}

	renderContentOn(html) {
		html.div(
			{ class: "published-forecast-archive" },
			this._renderPublishedForecastsOn.bind(this),
		);
	}

	_forecastCardRenderer(forecast) {
		const cardContent = regionWidget({
			content: (html) => {
				html.render(
					new ForecastArchiveCardWidget({
						forecast,
						forecastUrl: this._getForecastUrl({ forecast }),
						onDeletionRequest:
							this._documentState.canForecastBeDeleted(
								forecast,
							) &&
							(async () => {
								await this._documentState.deleteForecast(
									forecast,
								);

								this._listSource.fetch();
							}),
						onEstimateTagChangeRequest: async () => {
							await this._documentState.toggleEstimateTag({
								forecast,
							});

							cardContent.update();
						},
					}),
				);
			},
		});

		return cardContent;
	}

	_forecastCardGroupRenderer(isoString) {
		return formatAsLongMonthAndYear(new Date(isoString));
	}

	_sortGroupPeriods(isoStringA, isoStringB) {
		return new Date(isoStringB) - new Date(isoStringA);
	}

	_renderPublishedForecastsOn(html) {
		html.div(this._publishedForecastList);
	}

	_getPublishedForecastSource() {
		return this._documentState.getPublishedForecastSource();
	}
}
